import { Body1 } from '@flatsy/core/MaterialUi/Typo'
import React, { useContext } from 'react'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { FileContext } from 'src/containers/Application/Files/Context'
import { getFilesByMainKind } from '@flatsy/utils/Functions/Files/GetFilesByKind'
import { getMainKindStatus } from '@flatsy/utils/Functions/Files/GetMainKindStatus'
import { StatusType } from '@flatsy/types/Status'
import CancelIcon from '@material-ui/icons/Cancel'
import i18n from '@flatsy/utils/translations'
import { FilesMainKind } from '@flatsy/types/Files'
import { RequiredItemType } from './Type'
import useStyles from './Style'

const RequiredItem: React.FC<RequiredItemType> = ({ mainKind }) => {
  const classes = useStyles()
  const {
    files: { filesByApplicant },
    Uppy,
  } = useContext(FileContext)
  const filesByKind = getFilesByMainKind(filesByApplicant, mainKind.kind)
  const kindStatus = getMainKindStatus({
    files: filesByKind,
    requiredUpload: mainKind,
    includeUppyFile: Uppy?.formatedFiles,
  })

  const getMainKindTranslate = (kind: FilesMainKind) => {
    switch (kind) {
      case FilesMainKind.PROOF_OF_ID:
        return i18n.t('proof_of_id')
      case FilesMainKind.PROOF_OF_RESIDENCE:
        return i18n.t('certificate_of_accommodation')
      case FilesMainKind.PROOF_OF_WORK:
        return i18n.t('employer_certificate')
      case FilesMainKind.PROOF_OF_REVENUE:
        return i18n.t('pay_slip')
      case FilesMainKind.TAX_NOTICE:
        return i18n.t('tax_notice')
      default:
        return kind
    }
  }

  if (kindStatus === StatusType.SUCCESS || kindStatus === StatusType.WAITING) {
    return (
      <div className={classes.container}>
        <CheckCircleIcon className={classes.successIcon} />
        <Body1 className={classes.successTitle}>{getMainKindTranslate(mainKind.kind)}</Body1>
      </div>
    )
  }
  if (kindStatus === StatusType.ERROR) {
    return (
      <div className={classes.container}>
        <CancelIcon className={classes.errorIcon} />
        <Body1 className={classes.errorTitle}>{getMainKindTranslate(mainKind.kind)}</Body1>
      </div>
    )
  }
  return (
    <ul className={classes.listContainer}>
      <li className={classes.list}>
        <div className={classes.container}>
          <Body1>{getMainKindTranslate(mainKind.kind)}</Body1>
        </div>
      </li>
    </ul>
  )
}

export default RequiredItem
